import { render, staticRenderFns } from "./BlockSidebar.vue?vue&type=template&id=17759ed2&"
import script from "./BlockSidebar.vue?vue&type=script&lang=js&"
export * from "./BlockSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports